import React from 'react'
import { useLicensingPaymentBreakdownCalculations } from '../../../../hooks/useLicensingPaymentBreakdownCalculations'
import {
  BreakdownLedgerForPDF,
  BreakdownLedgerForPDFStyles,
  BreakDownLedgerPDFVariants,
} from './BreakdownLedgerForPDF'
import { useTranslation } from 'react-i18next'

type SemesterTwoSubtotalBreakdownProps = Pick<
  ReturnType<typeof useLicensingPaymentBreakdownCalculations>,
  'semester2Subtotal' | 'semester2FirstStudent' | 'semester2AdditionalStudent'
> &
  BreakdownLedgerForPDFStyles & {
    isChallenge: boolean
    subHeaderLabel?: string
    displaySubTotalLabel?: boolean
  }

export const SemesterTwoSubtotalBreakdown: React.FC<
  SemesterTwoSubtotalBreakdownProps
> = ({
  isChallenge,
  semester2Subtotal,
  semester2FirstStudent,
  semester2AdditionalStudent,
  subHeaderCellCssProps,
  subHeaderRowCssProps,
  bodyCellCssProps,
  subTotalCellCssProps,
  nestedDescription,
  subHeaderLabel,
  displaySubTotalLabel,
}) => {
  const { t } = useTranslation()

  const secondSemesterLicensingTuitionLabel = t(
    'Licensing.Table.Breakdown.Header.SecondSemesterLicensingTuition',
    '2nd Semester Licensing Fee - Tuition'
  )

  if (isChallenge) {
    return (
      <BreakdownLedgerForPDF
        variant={BreakDownLedgerPDFVariants.Normal}
        headerLabel={subHeaderLabel || secondSemesterLicensingTuitionLabel}
        firstStudent={semester2FirstStudent}
        additionalStudent={semester2AdditionalStudent}
        subtotal={semester2Subtotal}
        subHeaderCellCssProps={subHeaderCellCssProps}
        subHeaderRowCssProps={subHeaderRowCssProps}
        bodyCellCssProps={bodyCellCssProps}
        subTotalCellCssProps={subTotalCellCssProps}
        nestedDescription={nestedDescription}
        displaySubTotalLabel={displaySubTotalLabel}
      />
    )
  }

  return <></>
}
